import React from 'react'
import { Card, CardTitle, CardText } from 'material-ui-legacy/Card'

import { MarginFormatter, ColorCurrencyFormatter } from '../UI/FormatProviders'
import LinearLoader from '../UI/LinearLoader'
import './styles/quotes.css'

/*
Props:
- actual: an actual object
- style: CSS for the enclosing card (optional)
*/
const ActualCostSummary = props => {
  const { actual, style } = props
  if (!actual) return <LinearLoader />

  const summary = actual.attributes.formattedSummary
  const cardStyle = style || { marginTop: '40px' }
  const cardTextStyle = {
    display: 'flex',
    justifyContent: 'center'
  }
  const columnStyle = {
    marginRight: '40px'
  }

  return (
    <Card style={cardStyle} className="client-facing-quote-screen">
      <CardTitle
        title="Actual cost & margin summary"
        subtitle="Internal, not shown to client"
      />

      <CardText style={cardTextStyle}>
        <section style={columnStyle}>
          <h3>Original quote</h3>
          <p>
            <strong>Gross cost:</strong> {summary.formattedGrossCost}
          </p>
          <p>
            <strong>Gross total:</strong> {summary.formattedGrossTotal}
          </p>
          <p>
            <strong>Gross margin:</strong>{' '}
            <MarginFormatter value={summary.grossMargin * 100} />
          </p>
        </section>

        <section style={columnStyle}>
          <h3>Actual</h3>
          <p>
            <strong>Actual gross cost:</strong>{' '}
            {summary.formattedActualGrossCost}
          </p>
          <p>
            <strong>Actual gross total:</strong>{' '}
            {summary.formattedActualGrossTotal}
          </p>
          <p>
            <strong>Actual gross margin:</strong>{' '}
            <MarginFormatter value={summary.actualGrossMargin * 100} />
          </p>

          <h3>Difference</h3>
          <p>
            <strong>Dollar delta:</strong>{' '}
            <ColorCurrencyFormatter value={summary.dollarDelta} />
          </p>
          <p>
            <strong>Percentage delta:</strong>{' '}
            <MarginFormatter value={summary.percentageDelta * 100} />
          </p>
        </section>
      </CardText>
    </Card>
  )
}

export default ActualCostSummary



// WEBPACK FOOTER //
// ./src/components/Quotes/ActualCostSummary.jsx